import {
  CreateCustomTimeRangeCategoryDocument,
  CreateCustomTimeRangeCategoryMutationVariables,
  GetCustomTimeRangeCategoriesDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useCreateCustomTimeRangeCategory = () => {
  const [createCustomTimeRangeCategory, { loading }] = useMutation(
    CreateCustomTimeRangeCategoryDocument,
    {
      extractorFn: (data) => data.attendanceMutations.createAttendanceCustomTimeRangeCategory,
    }
  )

  const create = (variables: CreateCustomTimeRangeCategoryMutationVariables) => {
    return createCustomTimeRangeCategory({
      variables,
      refetchQueries: [GetCustomTimeRangeCategoriesDocument],
    })
  }

  return {
    loading,
    create,
  }
}
